import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LocalStorageService } from '../service/localstorage.service';

/**
 * 登入/註冊請求的 body 附加指紋辨識欄位。
 *
 * 後端 log 只記 body、不記自訂 header —— `Fp-Visitor-Id` header 後端
 * 一直看不到，這正是先前追查異常指紋用量時「來源資訊不足」的根因。
 * 用攔截器單點注入，九個 auth 端點的呼叫端與參數型別都不用動。
 *
 * - visitorIdPro：設備識別碼，同設備所有嘗試共用，供 log 按設備聚合
 * - fpRequestId：最近一次識別事件編號，後端可拿去 Fingerprint 的
 *   GET /events/{requestId} 驗證真偽並回查該次的 bot 判定
 *
 * 只處理物件 body 的請求(auth/setup 的 body 是字串，略過)。
 */
@Injectable()
export class AuthContextInterceptor implements HttpInterceptor {
  constructor(private localStorageService: LocalStorageService) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const isAuth = req.url.includes('/v1/member/auth/');
    const isPlainBody =
      typeof req.body === 'object' && req.body !== null && !Array.isArray(req.body) && !(req.body instanceof FormData);
    if (!isAuth || !isPlainBody) {
      return next.handle(req);
    }
    return next.handle(
      req.clone({
        body: {
          ...req.body,
          clientCtx: {
            visitorIdPro: this.localStorageService.visitorIdPro || '',
            fpRequestId: this.localStorageService.fpRequestId || '',
          },
        },
      }),
    );
  }
}
